export const SEND_BTN_CHAT_WRAPPER = 'sendButtonChatWrapper';
export const NOTIFICATION_CHAT_WRAPPER = 'notificationChatWrapper';
export const PRECHAT_DEFAULT_UI_CLASS = '.prechatUI.embeddedServiceLiveAgentStatePrechatDefaultUI';
export const PRECHAT_WELCOME_WRAPPER = 'preChatWelcomeWrapper';
export const SALESFORCE_CHAT_SCRIPT = 'salesforce-chat-script';
export const UPDATE_AGENT_AVAIL_LISTENER = 'updateAgentAvailability';

export const initializeChatSDK = (
  publicRuntimeConfig?: Record<string, unknown>,
  gslbBaseURL?: string | null,
  handlers?: Record<string, unknown>
): void => {
  try {
    const origin = typeof window !== 'undefined' && window.location.origin ? window.location.origin : '';

    window.embedded_svc.settings.displayHelpButton = false;
    window.embedded_svc.settings.language = 'en-US';
    window.embedded_svc.settings.storageDomain = 'pizzahut.com';
    window.embedded_svc.settings.enabledFeatures = ['LiveAgent'];
    window.embedded_svc.settings.entryFeature = 'LiveAgent';
    window.embedded_svc.settings.smallCompanyLogoImgURL = `${origin}/images/icons/icon-chat-white.svg`;
    window.embedded_svc.settings.avatarImgURL = `${origin}/images/icons/icon-chat-pizza-hut.svg`;

    window.embedded_svc.addEventHandler('onAvailability', handlers?.agentAvailabilityHandler);
    window.embedded_svc.addEventHandler('onSettingsCallCompleted', handlers?.chatInitCallCompletedHandler);
    window.embedded_svc.addEventHandler('onAgentMessage', handlers?.newAgentMessageHandler);
    window.embedded_svc.addEventHandler('onChatEstablished', handlers?.chatEstablishedHandler);
    window.embedded_svc.addEventHandler('afterMaximize', handlers?.afterMaximizeHandler);

    window.embedded_svc.settings.prepopulatedPrechatFields = {
      origin: 'chat'
    };

    window.embedded_svc.init(
      publicRuntimeConfig?.SALESFORCE_PH_CHAT_URL_BASE,
      publicRuntimeConfig?.SALESFORCE_PH_CHAT_URL_STORE,
      gslbBaseURL,
      publicRuntimeConfig?.SALESFORCE_PH_URL_KEY,
      'PH_Live_Chat', {
        baseLiveAgentContentURL: publicRuntimeConfig?.SALESFORCE_PH_LIVE_AGENT_URL_CONTENT,
        deploymentId: '5723x000000bsb3',
        buttonId: '5733x000000g4lS',
        baseLiveAgentURL: publicRuntimeConfig?.SALESFORCE_PH_LIVE_AGENT_URL_CHAT,
        eswLiveAgentDevName: 'EmbeddedServiceLiveAgent_Parent04I3x000000kBeYEAU_18b166b4545',
        isOfflineSupportEnabled: false
      }
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error initializing chat SDK: ', error);
  }
};
